const $ = jQuery.noConflict()


$.fn.extend({
  statementContent: function() {
    self.init('.statement__title--tab')
  }
})

var self = module.exports = {
  init: function(trigger) {
    // console.log(trigger);
    self.events.hover(trigger)
    self.events.click()
  },

  events: {
    hover: function(trigger) {
      $(trigger).on('mouseover', function() {
        var imageTarget = $(this).data('statement-content');
        self.service.disableSiblings($(this), imageTarget)
        self.service.activateTab($(this), imageTarget)
      })
    },
    click: function(trigger) {
      $('.statement__title--mobile').on('click', function() {
        let $this = $(this);

        if ($this.next().hasClass('show')) {
            $this.next().removeClass('show');
            $this.next().slideUp(350);
            $this.removeClass('active');
        } else {
            $this.parent().parent().find('.statement__content .statement__inner-content').removeClass('show');
            $this.parent().parent().find('.statement__title--mobile').removeClass('active');
            $this.parent().parent().find('.statement__content .statement__inner-content').slideUp(350);
            $this.next().toggleClass('show');
            $this.toggleClass('active');
            $this.next().slideToggle(350);
        }
      })
    },
  },

  service: {
    disableSiblings: function(target, imageTarget) {
      $(target).siblings().removeClass('active');
      $(imageTarget).siblings().removeClass('active');
    },
    activateTab: function(target, imageTarget) {
      $(target).addClass('active');
      $(imageTarget).addClass('active');
    },
  }
}
